<template>
  <div style="position: relative;">
    <el-form ref="consultAuditPageFilter" :model="consultAuditPage" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
<!--        <el-form-item label="是否审核" prop="formFilter.auditFlag">-->
<!--          <el-select class="filter-item" v-model="consultAuditPage.formFilter.auditFlag" :clearable="true" filterable-->
<!--            placeholder="" :loading="consultAuditPage.auditFlag.impl.loading"-->
<!--            @visible-change="consultAuditPage.auditFlag.impl.onVisibleChange"-->
<!--            @change="onAuditFlagValueChange">-->
<!--            <el-option v-for="item in consultAuditPage.auditFlag.impl.dropdownList" :key="item.id"-->
<!--              :value="item.id" :label="item.name"-->
<!--            />-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item label="内容" prop="formFilter.searchString">
          <el-input class="filter-item" v-model="consultAuditPage.formFilter.searchString"
                    :clearable="true" placeholder="内容"
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetConsultAuditPage">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshConsultAuditPage(true)">查询</el-button>
<!--        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="moreAudit('1')">批量审核通过</el-button>-->
<!--        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="moreAudit('-1')">批量审核不通过</el-button>-->
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="specialistConsult" :data="consultAuditPage.SpecialistConsult.impl.dataList" :size="defaultFormItemSize" @sort-change="consultAuditPage.SpecialistConsult.impl.onSortChange"
          header-cell-class-name="table-header-gray"
          highlight-current-row @current-change="consultAuditPage.SpecialistConsult.impl.currentRowChange"
                  @selection-change="handleSelectionChange"
        >
          <el-table-column header-align="center"
                           align="center" type="selection" width="50px"
          />
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="consultAuditPage.SpecialistConsult.impl.getTableIndex" />
          <el-table-column type="expand">
            <template slot-scope="scope">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="回复内容">
                  <p>{{ scope.row.specialistReply }}</p>
                </el-form-item>
                <el-form-item label="回复时间">
                  <p>{{ scope.row.replyTime }}</p>
                </el-form-item>
                <el-form-item label="回复图片">
                  <p>
                    <el-image v-for="item2 in parseUploadData(scope.row.replyImages, {id: scope.row.id, fieldName:
                    'replyImages', asImage: true})"
                              :preview-src-list="getPictureList(scope.row.replyImages, {id: scope.row.id, fieldName: 'replyImages', asImage: true})"
                              class="table-cell-image" :key="item2.url" :src="item2.url" fit="fill">
                    <div slot="error" class="table-cell-image">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                  </p>

                </el-form-item>
              </el-form>
            </template>
          </el-table-column>

          <el-table-column label="创建人" prop="createUserName">
          </el-table-column>
          <el-table-column label="咨询内容" prop="consultContent">
          </el-table-column>
          <el-table-column label="对接专家名" prop="specialistName">
          </el-table-column>
          <el-table-column label="咨询内容附图" min-width="180px">
            <template slot-scope="scope">
              <el-image v-for="item in parseUploadData(scope.row.consultImages, {id: scope.row.id, fieldName: 'consultImages', asImage: true})"
                        :preview-src-list="getPictureList(scope.row.consultImages, {id: scope.row.id, fieldName: 'consultImages', asImage: true})"
                        class="table-cell-image" :key="item.url" :src="item.url" fit="fill">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="回复内容" prop="specialistReply">
            <template slot-scope="scope">
              <span v-if="scope.row.replyTime">已回复</span>
              <span v-else>未回复</span>
            </template>
          </el-table-column>
<!--          <el-table-column label="回复图片" min-width="180px">-->
<!--            <template slot-scope="scope">-->
<!--              <el-image v-for="item in parseUploadData(scope.row.replyImages, {id: scope.row.id, fieldName: 'replyImages', asImage: true})"-->
<!--                        :preview-src-list="getPictureList(scope.row.replyImages, {id: scope.row.id, fieldName: 'replyImages', asImage: true})"-->
<!--                        class="table-cell-image" :key="item.url" :src="item.url" fit="fill">-->
<!--                <div slot="error" class="table-cell-image">-->
<!--                  <i class="el-icon-picture-outline"></i>-->
<!--                </div>-->
<!--              </el-image>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column label="审核状态" prop="auditStatusDictMap.name">-->
<!--          </el-table-column>-->
          <el-table-column label="创建时间" prop="createTime">
          </el-table-column>
<!--          <el-table-column label="操作" fixed="right">-->
<!--            <template slot-scope="scope">-->
<!--              <el-button @click.stop="onUpdateAuditClick(scope.row, '1')" type="text" :size="defaultFormItemSize"-->
<!--                         v-if="scope.row.auditStatus === '0'"-->
<!--                :disabled="!checkPermCodeExist('consultAuditPage:consultAuditPage:updateAudit')">-->
<!--                审核通过-->
<!--              </el-button>-->
<!--              <el-button @click.stop="onUpdateAuditClick(scope.row, '-1')" type="text" :size="defaultFormItemSize"-->
<!--                         v-if="scope.row.auditStatus === '0'"-->
<!--                :disabled="!checkPermCodeExist('consultAuditPage:consultAuditPage:updateAudit')">-->
<!--                审核不通过-->
<!--              </el-button>-->
<!--              <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"-->
<!--                         v-if="scope.row.auditStatus !== '0'"-->
<!--                         :disabled="!checkPermCodeExist('consultAuditPage:consultAuditPage:updateAudit')">-->
<!--                删除-->
<!--              </el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->

        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="consultAuditPage.SpecialistConsult.impl.totalCount"
            :current-page="consultAuditPage.SpecialistConsult.impl.currentPage"
            :page-size="consultAuditPage.SpecialistConsult.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="consultAuditPage.SpecialistConsult.impl.onCurrentPageChange"
            @size-change="consultAuditPage.SpecialistConsult.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { DictionaryController, SpecialistConsultController } from '@/api';

export default {
  name: 'consultAuditPage',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      consultAuditPage: {
        formFilter: {
          auditFlag: undefined,
          searchString: undefined
        },
        formFilterCopy: {
          auditFlag: undefined,
          searchString: undefined
        },
        auditFlag: {
          impl: new DropdownWidget(this.loadAuditFlagDropdownList)
        },
        SpecialistConsult: {
          impl: new TableWidget(this.loadSpecialistConsultWidgetData, this.loadSpecialistConsultVerify, true, true, 'createTime', 1)
        },
        isInit: false
      },
      multiSelect: []
    }
  },
  methods: {
    /**
     * 批量审核
     */
    moreAudit (status) {
      if (this.multiSelect.length === 0) {
        this.$message.error('请至少勾选一条数据！');
      } else {
        let params = {
          consultList: this.multiSelect,
          status: status
        };

        console.log('params', params)
        SpecialistConsultController.updateAudit(this, params).then(res => {
          this.$message.success('操作成功');
          this.consultAuditPage.SpecialistConsult.impl.refreshTable(false, 1);
        }).catch(e => {});
      }
    },
    /**
     * 选中的值
     */
    handleSelectionChange (values) {
      console.log('values', values)
      this.multiSelect = values;
    },
    onResetConsultAuditPage () {
      this.$refs.consultAuditPageFilter.resetFields();
      this.refreshConsultAuditPage(true);
    },
    /**
     * 专家咨询表数据获取函数，返回Promise
     */
    loadSpecialistConsultWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        specialistConsultDtoFilter: {
          // auditStatus: this.consultAuditPage.formFilterCopy.auditFlag,
          auditStatus: '1',
          searchString: this.consultAuditPage.formFilterCopy.searchString
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        SpecialistConsultController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.consultAuditPage.SpecialistConsult.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.consultAuditPage.SpecialistConsult.impl.currentRow.id, 'id');
              this.$refs.specialistConsult.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 专家咨询表数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadSpecialistConsultVerify () {
      this.consultAuditPage.formFilterCopy.auditFlag = this.consultAuditPage.formFilter.auditFlag;
      this.consultAuditPage.formFilterCopy.searchString = this.consultAuditPage.formFilter.searchString;
      return true;
    },
    /**
     * 是否审核下拉数据获取函数
     */
    loadAuditFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictAuditStatusDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 是否审核选中值改变
     */
    onAuditFlagValueChange (value) {
    },
    /**
     * 更新专家咨询审核
     */
    refreshConsultAuditPage (reloadData = false) {
      if (reloadData) {
        this.consultAuditPage.SpecialistConsult.impl.refreshTable(true, 1);
      } else {
        this.consultAuditPage.SpecialistConsult.impl.refreshTable();
      }
      if (!this.consultAuditPage.isInit) {
        // 初始化下拉数据
      }
      this.consultAuditPage.isInit = true;
    },
    /**
     * 审核通过
     */
    onUpdateAuditClick (row, status) {
      let consultAudit = {
        id: row.id
      }
      this.multiSelect.push(consultAudit);
      let params = {
        consultList: this.multiSelect,
        status: status
      };
      console.log('params', params)
      SpecialistConsultController.updateAudit(this, params).then(res => {
        this.$message.success('操作成功');
        this.consultAuditPage.SpecialistConsult.impl.refreshTable(false, 1);
      }).catch(e => {});
    },
    onDeleteClick (row) {
      let params = {
        id: row.id
      };

      SpecialistConsultController.delete(this, params).then(res => {
        this.$message.success('删除成功');
        this.consultAuditPage.SpecialistConsult.impl.refreshTable(false, 1);
      }).catch(e => {});
    },
    onResume () {
      this.refreshConsultAuditPage();
    },
    initFormData () {
    },
    formInit () {
      this.refreshConsultAuditPage();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>

<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
</style>
